import moment from 'moment';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../data/constants/datetime';
import resolvePath from '../../misc/resolvePath';

// TODO: move this to a separated file and use it to validate schedule routes as well
export function RouteDateValidation(props) {
    if (props.match.params.date && moment(props.match.params.date, DATE_FORMAT_URL).isValid()) {
        return props.children;
    } else {
        let newPath = resolvePath(props.match.url, '..');
        return <Redirect to={newPath} />;
    }
}
